import { useMemo } from 'react';
import { useGLTF } from '@react-three/drei';
import * as THREE from 'three';

export function useCachedGLTF(url: string) {
  const { scene } = useGLTF(url ?? '') as { scene: THREE.Group }; 
  const cachedScene = useMemo(() => scene.clone(), [url]); 
  return cachedScene;
}
